/**
 * @license BCP
 * (c) 2015 Openprovider. http://openprovider.eu
 * @author Eugene Semennikov esemennikov@openprovider.ru
 * License: MIT
 */
(function() {'use strict';

/**
 * @ngdoc service
 * @name exportToCsv
 *
 * @description
 * export data to the CSV file format
 */
angular.module('BCP')
  .factory('exportToCsv', function (CSV, $timeout, $document, b17Service) {

    var data = {
      prices: [],
      config: {}
    };

    function downloadFile (data, csvOptions) {
      CSV.stringify(data, csvOptions).then(function (csv) {
        var blob = new Blob([csv], {type: "text/csv;charset=utf-8;"});
        if(navigator.msSaveBlob) {
          navigator.msSaveBlob(blob, filename);
        } else {
          var saveBlob = navigator.webkitSaveBlob || navigator.mozSaveBlob || navigator.saveBlob;
          if(saveBlob === undefined) {
            var downloadContainer = angular.element('<div data-tap-disabled="true"><a></a></div>');
            var downloadLink = angular.element(downloadContainer.children()[0]);
            downloadLink.attr('href', window.URL.createObjectURL(blob));
            downloadLink.attr('download', csvOptions.fileName);
            downloadLink.attr('target', '_blank');
            $document.find('body').append(downloadContainer);
            $timeout(function () {
              downloadLink[0].click();
              downloadLink.remove();
            }, null);
          } else {
            saveBlob(blob, csvOptions.filename);
          }
        }
      });
    }

    function downloadAllProductRecordsToFile (group, dataSource) {
      data.prices = dataSource;
      data.config = {};
      var versionNumber = 1; // general price version

      b17Service.getConfig().then(function (config) {
        if (config.data && config.data.data) {
          data.config = config.data.data.results[0];
          if (data.prices === undefined) {
            b17Service.getPrices({version: versionNumber}).then(function (result) {
              if (result.statusText === 'OK') {
                data.prices = result.data.data.results;
                privateExportToCsv(group);
              } else {
                checkErrorCodeMessage();
              }
            });
          } else {
            privateExportToCsv(group);
          }
        } else {
          checkErrorCodeMessage();
        }
      });
    }

    function privateExportToCsv (group) {
      var filteredPricesForExport = [];
      var pricesArrayTmp = {};
      var keyArray = [];

      var pricesArray = data.prices;

      if (group === 'domains') {
        pricesArray = pricesArray.filter(function (item) {
          return (item.article == 'default' && item.group == group);
        });
      } else {
        pricesArray = pricesArray.filter(function (item) {
          return item.group == group;
        });
      }

      pricesArray.forEach(function (item) {
        var key = item.product + "+zzz+" +
            item.article + "+zzz+" +
            item.operation + "+zzz+" +
            item.quantity;
        var flag = true;
        if (keyArray.indexOf(key) < 0) {
          keyArray.push(key);
        }
        if (pricesArrayTmp[key] === undefined) {
          pricesArrayTmp[key] = [];
          flag = false;
        } else {
          if (pricesArrayTmp[key][0][2] > item.tier['1.one']) {
            delete pricesArrayTmp[key];
            pricesArrayTmp[key] = [];
            flag = false;
          }
        }
        if (!flag) {
          var preparedArray = [];
          preparedArray.push(item.product);
          preparedArray.push(item.article);
          preparedArray.push(item.quantity);
          preparedArray.push(item.operation);
          data.config.tiers.forEach(function (tierName) {
            preparedArray.push(item.tier[tierName].toFixed(2));
          });
          var prime = item.cost + item.extras; // cost price for customers
          preparedArray.push(prime.toFixed(2));
          preparedArray.push(item.currency);
          pricesArrayTmp[key].push(preparedArray);
        }
      });

      keyArray.sort();
      keyArray.forEach(function (item) {
        filteredPricesForExport.push(pricesArrayTmp[item][0]);
      });

      var preparedHeader = [];
      preparedHeader.push('Product');
      preparedHeader.push('Type');
      preparedHeader.push('Period');
      preparedHeader.push('Operation');
      data.config.tiers.forEach(function (tierName) {
        preparedHeader.push(_.capitalize(tierName.substring(tierName.indexOf('.') + 1)));
      });
      preparedHeader.push('Prime');
      preparedHeader.push('Currency');
      var csvOptions = {
        header: preparedHeader,
        txtDelim: '"',
        decimalSep: '.',
        fieldSep: ",",
        fileName: 'opprices.csv'
      };

      downloadFile(filteredPricesForExport, csvOptions);
    }

    return {
      downloadFile: downloadFile,
      downloadAllProductRecordsToFile: downloadAllProductRecordsToFile
    };

  });

})();
